import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function MarketingHero() {
  return (
    <section className="container mx-auto px-4 py-20">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-6">
          Modern Library Management
          <span className="text-primary"> Made Simple</span>
        </h1>
        <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
          Streamline your library operations with our comprehensive multi-tenant SaaS platform.
          Manage catalogs, circulation, and patrons all in one place.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" asChild>
            <Link to="/onboard">Get Started Free</Link>
          </Button>
          <Button size="lg" variant="outline" asChild>
            <a href="#features">Learn More</a>
          </Button>
        </div>
      </div>
    </section>
  );
}
